/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import Videos from './videos'
import MeetNewFriends from 'src/components/shared/modules/meetNewFriends'
import BrandsCollab from 'src/components/shared/modules/brandsCollab'
import { Box } from '@mui/material'
import { contentType } from 'src/types/components/shared/atom'
import useStyles from 'src/styles/pages/dtlOriginalsStyle'
import HeroHeader from 'src/components/shared/modules/heroHeader/HeroHeader'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'
// import { useGetPageByNameQuery } from 'src/store/ApiCall/pagesAPI'
import Skeleton from 'src/components/shared/modules/skeleton'
import SocialMedia from 'src/components/shared/modules/socialMedia'
import { HeadingTextButton } from 'src/types/store'
import HeadTag from 'src/components/layout/head'
interface btnData {
  id: number
  content: string
  href: string
}
interface meetNewFriendI {
  heading: string
  para: string
  btnDetail: btnData
}
interface IProps {
  data?: any
}
function DtlOriginals({ data }: IProps) {
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)
  // const { data } = useGetPageByNameQuery('dtlOriginals')
  const { classes } = useStyles()

  const [header, setHeader] = useState<contentType>()
  const [meetNewFriends, setMeetNewFriends] = useState<meetNewFriendI>()
  const [campaignHeader, setCampaignHeader] = useState<HeadingTextButton>()
  const [searchPlaceHolder, setSearchPlaceHolder] = useState<string>()
  const [dtlTabContent, setDtlTabContent] = useState<{
    tab1: string
    tab2: string
  }>()
  useEffect(() => {
    if (data && data.data.length > 0) {
      const content = data.data[0].attributes
      const { heroHeader, meetNewFriend, campaignVideoList, dtlOriginalsTabs } =
        content

      if (heroHeader) {
        const {
          primaryText,
          secondaryText,
          tertiaryText,
          topics,
          searchPlaceholder,
        } = heroHeader
        const headerText: contentType = {
          content: {
            secondary: {
              content: secondaryText,
              variant: 'h3',
              type: 'secondary',
            },
            primary: {
              content: primaryText,
              variant: 'h1',
              type: 'primary',
            },
            tertiary: {
              content: tertiaryText,
              variant: 'subtitle1',
              type: 'tertiary',
            },
          },
          topics: topics.data.map(
            (curr: { id: number; attributes: { topic: string } }) => {
              return {
                id: curr.id,
                content: curr.attributes.topic,
                href: curr.attributes.topic ? curr.attributes.topic : '#',
              }
            }
          ),
        }

        setHeader(headerText)
        if (searchPlaceholder) setSearchPlaceHolder(searchPlaceholder)
      }
      if (meetNewFriend) {
        setMeetNewFriends({
          heading: meetNewFriend.heading,
          para: meetNewFriend.text,
          btnDetail: {
            id: meetNewFriend.button.id,
            content: meetNewFriend.button.content,
            href: meetNewFriend.button.href ? meetNewFriend.button.href : '',
          },
        })
      }
      if (campaignVideoList) setCampaignHeader(campaignVideoList)
      if (dtlOriginalsTabs) setDtlTabContent(dtlOriginalsTabs)
    }
  }, [data])

  return (
    <>
      <HeadTag
        title={data?.data[0].attributes.metaTitle}
        description={data?.data[0].attributes.metaDescription}
      />
      <div>
        {header ? (
          <HeroHeader
            searchField={true}
            endAdornment={false}
            placeHolder={searchPlaceHolder}
            heroContent={header}
            homeIcon={false}
            populartopicsDisabled={true}
          />
        ) : (
          <Skeleton />
        )}

        <div className={classes.outerContainer}>
          <div className={classes.dtlOriginalsContainer}>
            {dtlTabContent ? <Videos tabContent={dtlTabContent} /> : ''}

            <Box mt={12} mb={23}>
              <SocialMedia zenMode={zenMode} />
            </Box>
            {campaignHeader ? (
              <BrandsCollab headerContent={campaignHeader} />
            ) : (
              ''
            )}

            {meetNewFriends ? (
              <MeetNewFriends content={meetNewFriends} zenMode={zenMode} />
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default DtlOriginals
